import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGwMaengelStatusListStatus: 'idle',
    loadGwMaengelStatusListError: undefined as any,
    loadGwMaengelStatusListLastArgs: undefined as any,
    loadGwMaengelStatusStatus: 'idle',
    loadGwMaengelStatusError: undefined as any,
    saveGwMaengelStatusStatus: 'idle',
    saveGwMaengelStatusError: undefined as any,
    deleteGwMaengelStatusStatus: 'idle',
    deleteGwMaengelStatusError: undefined as any,

    gwMaengelStatusList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGwMaengelStatusList = createAsyncThunk('gwMaengelStatusSlice/loadGwMaengelStatusList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().gwMaengelStatusSlice.loadGwMaengelStatusListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwmnglstatus/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwMaengelStatusListStatus } = getState().gwMaengelStatusSlice
        return loadGwMaengelStatusListStatus !== 'pending'
    }
})

export const loadGwMaengelStatus = createAsyncThunk('gwMaengelStatusSlice/loadGwMaengelStatus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwmnglstatus/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwMaengelStatusStatus } = getState().gwMaengelStatusSlice
        return loadGwMaengelStatusStatus !== 'pending'
    }
})

export const saveGwMaengelStatus = createAsyncThunk('gwMaengelStatusSlice/saveGwMaengelStatus', async ({ gwMaengelStatus }: any, { rejectWithValue }: any) => {
    let promises = []
    if (gwMaengelStatus?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisgwmnglstatus/${ gwMaengelStatus?.HDR_ID }/`,
            prepareData(gwMaengelStatus),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisgwmnglstatus/`,
            prepareData(gwMaengelStatus),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGwMaengelStatusStatus } = getState().gwMaengelStatusSlice
        return saveGwMaengelStatusStatus !== 'pending'
    }
})

export const deleteGwMaengelStatus = createAsyncThunk('gwMaengelStatusSlice/deleteGwMaengelStatus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisgwmnglstatus/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGwMaengelStatusStatus } = getState().gwMaengelStatusSlice
        return deleteGwMaengelStatusStatus !== 'pending'
    }
})

const GwMaengelStatusSlice = createSlice({
    name: 'gwMaengelStatusSlice',
    initialState,
    reducers: {
        resetloadGwMaengelStatusListError: (state) => {
            state.loadGwMaengelStatusListError = undefined
        },
        resetloadGwMaengelStatus: (state) => {
            state.formItem = undefined
            state.loadGwMaengelStatusError = undefined
        },
        resetloadGwMaengelStatusError: (state) => {
            state.loadGwMaengelStatusError = undefined
        },
        resetsaveGwMaengelStatus: (state) => {
            state.formItem = undefined
            state.saveGwMaengelStatusError = undefined
        },
        resetsaveGwMaengelStatusError: (state) => {
            state.saveGwMaengelStatusError = undefined
        },
        resetdeleteGwMaengelStatusError: (state) => {
            state.deleteGwMaengelStatusError = undefined
        },
        removeFromGwMaengelStatusListById: (state, action) => {
            state.gwMaengelStatusList = state.gwMaengelStatusList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGwMaengelStatusListByIds: (state, action) => {
            state.gwMaengelStatusList = state.gwMaengelStatusList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.gwMaengelStatusList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGwMaengelStatusListStatus = 'preloaded'
            state.loadGwMaengelStatusListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.gwMaengelStatusList = []
            state.loadGwMaengelStatusListStatus = 'idle'
            state.loadGwMaengelStatusListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGwMaengelStatusList.pending, (state) => {
            state.loadGwMaengelStatusListStatus = 'pending'
            state.loadGwMaengelStatusListError = undefined
        })
        builder.addCase(loadGwMaengelStatusList.fulfilled, (state, action) => {
            state.loadGwMaengelStatusListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGwMaengelStatusListLastArgs = action.payload.args

            {
                state.gwMaengelStatusList = action.payload.data

            }
        })
        builder.addCase(loadGwMaengelStatusList.rejected, (state, action) => {
            state.loadGwMaengelStatusListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwMaengelStatusListError = action.error.message
            } else {
                state.loadGwMaengelStatusListError = action.payload
            }
        })

        builder.addCase(loadGwMaengelStatus.pending, (state) => {
            state.loadGwMaengelStatusStatus = 'pending'
            state.loadGwMaengelStatusError = undefined
        })
        builder.addCase(loadGwMaengelStatus.fulfilled, (state, action) => {
            state.loadGwMaengelStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwMaengelStatusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwMaengelStatusList.push(newItem) }
                else { state.gwMaengelStatusList[i] = { ...state.gwMaengelStatusList[i], ...newItem } }
            }
        })
        builder.addCase(loadGwMaengelStatus.rejected, (state, action) => {
            state.loadGwMaengelStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwMaengelStatusError = action.error.message
            } else {
                state.loadGwMaengelStatusError = action.payload
            }
        })

        builder.addCase(saveGwMaengelStatus.pending, (state) => {
            state.saveGwMaengelStatusStatus = 'pending'
            state.saveGwMaengelStatusError = undefined
        })
        builder.addCase(saveGwMaengelStatus.fulfilled, (state, action) => {
            state.saveGwMaengelStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwMaengelStatusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwMaengelStatusList.push(newItem) }
                else { state.gwMaengelStatusList[i] = { ...state.gwMaengelStatusList[i], ...newItem } }
            }
        })
        builder.addCase(saveGwMaengelStatus.rejected, (state, action) => {
            state.saveGwMaengelStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGwMaengelStatusError = action.error.message
            } else {
                state.saveGwMaengelStatusError = action.payload
            }
        })

        builder.addCase(deleteGwMaengelStatus.pending, (state) => {
            state.deleteGwMaengelStatusStatus = 'pending'
            state.deleteGwMaengelStatusError = undefined
        })
        builder.addCase(deleteGwMaengelStatus.fulfilled, (state, action) => {
            state.deleteGwMaengelStatusStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.gwMaengelStatusList = state.gwMaengelStatusList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.gwMaengelStatusList = state.gwMaengelStatusList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGwMaengelStatus.rejected, (state, action) => {
            state.deleteGwMaengelStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGwMaengelStatusError = action.error.message
            } else {
                state.deleteGwMaengelStatusError = action.payload
            }
        })

    }
})

export const {
    resetloadGwMaengelStatusListError,
    resetloadGwMaengelStatus,
    resetloadGwMaengelStatusError,
    resetsaveGwMaengelStatus,
    resetsaveGwMaengelStatusError,
    resetdeleteGwMaengelStatusError,
    removeFromGwMaengelStatusListById,
    removeFromGwMaengelStatusListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GwMaengelStatusSlice.actions
export default GwMaengelStatusSlice.reducer
